module.exports = __webpack_public_path__ + "img/playstore.3deb7cc2.webp";